
    export interface IPaymentCaptureResponse {
        responseMessage: string;
        responseCode: number;
    }

    export class PaymentCaptureResponse implements IPaymentCaptureResponse {
        responseMessage: string;
        responseCode: number;
    }
